export const REGISTER_USER = 'REGISTER_USER'
